module["exports"] = [
  "Schweiz"
];
